<template>
  <div class="list-wrap">
    <div class="gray-92 content-title">主页</div>
    <div class="content-tabs">
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeName === 'recentlyLook' }"
          @click="
            () => {
              activeName = 'recentlyLook';
            }
          "
        >
          最近访问
        </div>
        <div
          class="tab"
          :class="{ active: activeName === 'recentlyDownload' }"
          @click="
            () => {
              activeName = 'recentlyDownload';
            }
          "
        >
          最近下载
        </div>
      </div>
      <tab-look-com
        :visible="activeName === 'recentlyLook'"
        v-show="activeName === 'recentlyLook'"
      ></tab-look-com>
      <tab-download-com
        :visible="activeName === 'recentlyDownload'"
        v-show="activeName === 'recentlyDownload'"
      ></tab-download-com>
    </div>
  </div>
</template>
<script>
import tabLookCom from "./tabLook.vue";
import tabDownloadCom from "./tabDownload.vue";

export default {
  components: {
    tabLookCom,
    tabDownloadCom,
  },
  data() {
    return {
      activeName: "recentlyLook",
    };
  },
};
</script>
<style lang="scss" scoped>
.list-wrap {
  height: 100%;
  .content-title {
    line-height: 44px;
    font-size: 15px;
    padding: 0 0 0 23px;
    border-bottom: 1px solid rgba(231, 232, 234, 1);
  }
  .content-tabs {
    padding: 0 23px;
    .tabs {
      border-bottom: 1px solid #e7e8ea;
      display: flex;
      .tab {
        font-size: 14px;
        color: #5c5d5e;
        margin-right: 24px;
        line-height: 45px;
        cursor: pointer;
        border-bottom: 1px solid #e7e8ea;
        margin-bottom: -1px;
        &.active {
          color: #45b13b;
          border-bottom: 2px solid #45b13b;
        }
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.gray-92 {
  color: rgba(92, 93, 94, 1);
}
.gray-140 {
  color: rgba(140, 141, 142, 1);
}
.font-size-16 {
  font-size: 16px;
}
.font-size-14 {
  font-size: 14px;
}
</style>
